import { call, put, takeLeading } from 'redux-saga/effects';
import { types } from '@actions/errorLogger';
import { logError } from '@services/errorLoggerResource';

export function* logErrorSaga(action) {
  try {
    const err = (({ error, details }) => ({ error, details }))(action);
    yield call(logError, err);
    yield put({
      type: types.LOG_ERROR.SUCCESS,
      message: 'The error has been reported.',
    });
  } catch (err) {
    yield put({
      type: types.LOG_ERROR.FAILURE,
      message: err.message || 'Failed to report the error.',
    });
  }
}

export default function*() {
  yield takeLeading(types.LOG_ERROR.STARTED, logErrorSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/errorLogger.js